module.exports = __webpack_public_path__ + "static/media/wsp_icon_black.27695e07.svg";